import { ObservableArray, View } from "binder"
import { form, ProcessFormsViewModel } from "./processForms-viewModel"
import { FormBuilderWindowViewModel } from "src/formBuilder/formBuilder/formBuilderWindow-viewModel";

export class ProcessFormsView extends View<ProcessFormsViewModel>{
    GetViewUniqueId(): string {
        return "V-D4B66605-EEB3-4196-B1CC-55AF0FDF0FEA"
    }
    loadHtml(): string {
        let element = require('./processForms.html').default;
        let style = require('./processForms.less');
        return element;
    }
    constructor() {
       super();
    }
    public set forms(v: ObservableArray<form>) { this._forms = v; } public get forms(): ObservableArray<form> { return this._forms;} private _forms: ObservableArray<form>;
    public set selectedForm(v: form) { this._selectedForm = v; } public get selectedForm(): form { return this._selectedForm;} private _selectedForm: form;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set newFormName(v: string) { this._newFormName = v; } public get newFormName(): string { return this._newFormName;} private _newFormName: string;
    public set formPath(v: string) { this._formPath = v; } public get formPath(): string { return this._formPath;} private _formPath: string;
    public set formBuilder(v: FormBuilderWindowViewModel) { this._formBuilder = v; } public get formBuilder(): FormBuilderWindowViewModel { return this._formBuilder;} private _formBuilder: FormBuilderWindowViewModel;

    createForm(){
        this.dataContext.createForm();
    }
    saveForm(){
        this.dataContext.saveForm();
    }
    export(){
        this.dataContext.export();
    }
    import(){
        this.dataContext.import();
    }
    updateFormPath(){
        this.dataContext.updateFormPath();
    }
    updateFormName(){
        this.dataContext.updateFormName();
    }
    deleteForm(){
        this.dataContext.deleteForm();
    }
}
